import AuthAxios from '../axios';

  // default 주소는 deepLink 아님 이전부터 사용했던 기기별 스토어, 웹사이트 리다이렉트용 (혹시나 링크 없을 경우)
export const DeepLinkDefaultLink = 'https://tosto.re/soundpill1'

const DEEP_LINK_LOCAL_STORAGE_ID = 'deepLinkId';
export const deepLinkLocalStoreUtil = (param?: { isDelete?: boolean; newId?: string }) => {
  if (param?.newId) {
    localStorage.setItem(DEEP_LINK_LOCAL_STORAGE_ID, param.newId);
  }
  if (param?.isDelete) {
    localStorage.removeItem(DEEP_LINK_LOCAL_STORAGE_ID);
  }
  return localStorage.getItem(DEEP_LINK_LOCAL_STORAGE_ID);
};

export const getDeepLinkUri = async (deepLinkId: string) => {
  try {
    if (deepLinkId) {
      const result = await AuthAxios.get(`/deep-link?id=${deepLinkId}`);
      if (result?.data?.isSuccess && result?.data?.deepLinkInfo?.deepLinkURI) {
        return result?.data?.deepLinkInfo?.deepLinkURI;
      } else {
        throw new Error('Incorrect isSuccess property');
      }
    }
  } catch (error) {
    console.error('getDeepLinkURI', error);
    return DeepLinkDefaultLink;
  }
};
